import { SetUserActionType } from 'data/actions'

import * as AT from './actionTypes'
import { CurrencyDefinitionType, InstrumentType, SymbolType } from './types'

export type SetFavoritesActionType = {
  payload: { favorites: SymbolType[] }
  type: typeof AT.SET_FAVORITES
}

export type RemoveFavoriteActionType = {
  payload: { symbol: SymbolType }
  type: typeof AT.REMOVE_FAVORITE
}

export type SetSymbolActionType = {
  payload: {
    prevSymbol: SymbolType
    symbol: SymbolType
  }
  type: typeof AT.SET_SYMBOL
}

export type InstrumentActionType =
  | SetFavoritesActionType
  | {
      payload: { symbol: SymbolType }
      type: typeof AT.ADD_FAVORITE
    }
  | RemoveFavoriteActionType
  | {
      payload: { instruments: InstrumentType[] }
      type: typeof AT.SET_ALL
    }
  | {
      payload: { currencies: CurrencyDefinitionType[] }
      type: typeof AT.SET_CURRENCIES
    }
  | SetSymbolActionType
  | SetUserActionType
  | {
      payload: { instrument: InstrumentType }
      type: typeof AT.SET_UPDATE
    }
  | {
      type: typeof AT.STOP
    }

const setFavorites = (favorites: SymbolType[]): InstrumentActionType => ({
  payload: { favorites },
  type: AT.SET_FAVORITES
})

const addFavorite = (symbol: SymbolType): InstrumentActionType => ({
  payload: { symbol },
  type: AT.ADD_FAVORITE
})

const removeFavorite = (symbol: SymbolType): InstrumentActionType => ({
  payload: { symbol },
  type: AT.REMOVE_FAVORITE
})

const setAll = (instruments: InstrumentType[]): InstrumentActionType => ({
  payload: { instruments },
  type: AT.SET_ALL
})

const setCurrencies = (currencies: CurrencyDefinitionType[]): InstrumentActionType => ({
  payload: { currencies },
  type: AT.SET_CURRENCIES
})

const setSymbol = (symbol: SymbolType, prevSymbol: SymbolType): InstrumentActionType => ({
  payload: { prevSymbol, symbol },
  type: AT.SET_SYMBOL
})

const updateInstrument = (instrument: InstrumentType): InstrumentActionType => ({
  payload: { instrument },
  type: AT.SET_UPDATE
})

const stop = (): InstrumentActionType => ({
  type: AT.STOP
})

export default {
  addFavorite,
  removeFavorite,
  setAll,
  setCurrencies,
  setFavorites,
  setSymbol,
  stop,
  updateInstrument
}
